import * as types from "../constants/actionTypes";

export const commonReducerInitialState = {
    hideBannerOnCrash: false,
    stayOnIncompleteForm: false,
    rxDown: window.serverData.data.rxDown,
    aalDown: window.serverData.data.aalDown,
    swhpDown: window.serverData.data.swhpDown,
    epicEHRDown: window.serverData.data.epicEHRDown,
    normalAppUpdateShow: true,
    screenBreakPoint: ''
};

export default function commonReducer(state = commonReducerInitialState, action) {
    const type = action.type;

    if (typeof type === 'string') {
        if (type === types.STAY_ON_INCOMPLETE_FORM) {
            return { ...state, stayOnIncompleteForm: action.stay };
        }
        else if (type === types.USER_TO_SWITCH) {
            return { ...state, userToSwitch: action.user };
        }
        else if (type.indexOf('pharmacyProxy') === 0 || type === types.PHARMACY_NOTIFICATION_PREFERENCE_SAVE || type.indexOf('mychartProxy') === 0 || type.indexOf('healthRecordProxy') === 0 || type.indexOf('hrp_proxyRequestData') === 0 || type === types.CARE_COACH_NOTIFICATION_PREFERENCE_SAVE || type === types.GET_USER_NOTIFICATION_PREFERENCE) {
            if (action.success) {
                state[type] = { ...state[type], waiting: false, success: true, response: action.data, error: null };
            }
            else if (action.failure) {
                state[type] = { ...state[type], waiting: false, success: false, response: null, error: action.error };
            } else if (action.pData) {
                state[type] = { ...state[type], pData: action.pData };
            }
            else {
                state[type] = { waiting: true, request: action.data, response: null, error: null };//making response and error null as it is still waiting for response
            }
        }
        else if (type.indexOf('GET_APP_UPDATE') === 0) {
            if (action.success) {
                state[type] = { ...state[type], waiting: false, success: true, response: action.data, error: null };
            }
            else if (action.failure) {
                state[type] = { ...state[type], waiting: false, success: false, response: null, error: action.error };
            }
            else {
                state[type] = { waiting: true, request: action.data };
            }

            if (action.data !== undefined) {
                return { ...state, rxDown: action.data.rxDown, aalDown: action.data.aalDown, swhpDown: action.data.swhpDown, epicEHRDown: action.data.epicEHRDown };
            }
        }
        if (type === types.UPDATE_MENU) {
            return { ...state, currentLocation: action.currentLocation };
        }
        if (type === types.HIDE_BANNER_ON_CRASH) {
            return { ...state, hideBannerOnCrash: action.value };
        }
        if (type === types.INITIATE_PROXY_REQUEST)
            return { ...state, requestPending: null, requestSuccess: null, requestFailure: null };
        if (type === types.INITIATE_PROXY_REQUEST_FAILURE)
            return { ...state, requestPending: false, requestFailure: true };
        if (type === types.INITIATE_PROXY_REQUEST_PENDING)
            return { ...state, requestPending: true };
        if (type === types.INITIATE_PROXY_REQUEST_SUCCESS)
            return { ...state, requestPending: false, requestSuccess: true, requestFailure: false };
        if (type === types.COLLAPSE_MENU)
            return { ...state, showCollapsedMenu: action.showCollapsedMenu };
        if (type === types.SET_VIDEO_VISIT_TOASTR_MSG)
            return { ...state, videoVisitToastr: { message: action.message, successStatus: action.successStatus } };
        if (type === types.HIDE_NORMAL_APP_UPDATE)
            return { ...state, normalAppUpdateShow: false };
        if (type === types.SET_SCREEN_BREAKPOINT) {
            return { ...state, screenBreakPoint: action.screenBreakPoint };
        }
    }

    return state;
}